"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(value) {
  return typeof value === 'string' ? value.trim() : value;
};

exports.default = _default;